import { useResourceContext, useCreatePath } from "ra-core";
import { useNavigate } from "react-router";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export const MobileBackButton = (props: { resource?: string; to?: string }) => {
  const resource = useResourceContext(props);
  const navigate = useNavigate();
  const createPath = useCreatePath();
  const { to } = props;
  const finalTo =
    to ??
    createPath({
      resource,
      type: "list",
    });

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      // LDF: größere Tippfläche (44 px) fürs Handy
      className="-ml-2 size-11 rounded-full"
      aria-label={to ? "Zurück" : "Zurück zur Liste"}
      onClick={(e) => {
        e.preventDefault();
        // Auf dem Handy gibt es nicht zu jeder Seite eine Liste (z. B. Firmen) – dann einen Schritt zurück
        if (!to && window.history.length > 1) navigate(-1);
        else navigate(finalTo);
      }}
    >
      <ChevronLeft className="size-6" />
      <span className="sr-only">{to ? "Zurück" : "Zurück zur Liste"}</span>
    </Button>
  );
};
